import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';

const ThankYou = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-black text-white flex flex-col">
            <Navbar />
            
            <main className="flex-grow flex items-center justify-center px-6 py-24 relative overflow-hidden">
                {/* Background Decorations */}
                <div className="absolute top-1/4 -left-20 w-80 h-80 bg-blue-600/10 rounded-full blur-[120px] pointer-events-none"></div>
                <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-purple-600/10 rounded-full blur-[120px] pointer-events-none"></div>

                <div className="max-w-2xl w-full text-center relative z-10">
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ 
                            type: "spring",
                            stiffness: 260,
                            damping: 20,
                            delay: 0.2 
                        }}
                        className="w-24 h-24 bg-blue-600/20 rounded-full flex items-center justify-center mx-auto mb-8 border border-blue-500/30 shadow-[0_0_50px_rgba(37,99,235,0.2)]"
                    >
                        <CheckCircle className="w-12 h-12 text-blue-500" />
                    </motion.div>

                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.4 }}
                    >
                        <h1 className="text-4xl md:text-6xl font-normal mb-6 tracking-tight">
                            Thank You!
                        </h1>
                        <p className="text-xl md:text-2xl text-gray-400 font-light mb-4">
                            Your request has been submitted successfully
                        </p>
                        <p className="text-lg text-gray-500 mb-12">
                            Our team will contact you shortly to discuss your energy needs.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.6 }}
                        className="flex flex-col sm:flex-row items-center justify-center gap-4"
                    >
                        <button
                            onClick={() => navigate('/')}
                            className="w-full sm:w-auto px-8 py-4 bg-white text-black rounded-full font-medium hover:bg-gray-200 transition-all flex items-center justify-center gap-2 group"
                        >
                            <Home className="w-5 h-5" />
                            Back to Homepage
                        </button>
                        
                        <button
                            onClick={() => navigate('/solar')}
                            className="w-full sm:w-auto px-8 py-4 bg-transparent border border-gray-700 text-white rounded-full font-medium hover:bg-gray-900 transition-all flex items-center justify-center gap-2 group"
                        >
                            View Solar Services
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </button>
                    </motion.div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default ThankYou;
